<!-- eslint-disable max-len -->
<template>
  <div>
    <report-header
      :download="download"
      :report="report"
      :csv-data="csvData"
    />
    <div id="report">
      <report-result-query :query="query" />
      <v-card
        flat
        class="back"
        :loading="loading"
      >
        <div style="display: flex;align-items: center;justify-content: center;margin: 0 auto;text-align: center;flex-direction: row;">
          <report-result-box
            title="TOTAL DE TÍTULOS"
            :result="false"
          >
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Inclusão' || operationType === 'Todas as operações'"
            >
              Incluídos - {{ result.publicacoesIncluidas || 0 }}
            </p>
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Alteração' || operationType === 'Todas as operações'"
            >
              Alterados - {{ result.publicacoesAlteradas || 0 }}
            </p>
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Exclusão' || operationType === 'Todas as operações'"
            >
              Excluídos - {{ result.publicacoesExcluidas || 0 }}
            </p>
          </report-result-box>
          <report-result-box
            :result="false"
            title="TOTAL DE ITENS FÍSICOS"
          >
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Inclusão' || operationType === 'Todas as operações'"
            >
              Incluídos - {{ result.documentosIncluidosFisicos || 0 }}
            </p>
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Exclusão' || operationType === 'Todas as operações'"
            >
              Excluídos - {{ result.documentosExcluidosFisicos || 0 }}
            </p>
          </report-result-box>
          <report-result-box
            :result="false"
            title="TOTAL DE ITENS DIGITAIS"
          >
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Inclusão' || operationType === 'Todas as operações'"
            >
              Incluídos - {{ result.documentosIncluidosDigitais || 0 }}
            </p>
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Exclusão' || operationType === 'Todas as operações'"
            >
              Excluídos - {{ result.documentosExcluidosDigitais || 0 }}
            </p>
          </report-result-box>
          <report-result-box
            title="TOTAL GERAL DE ITENS"
            :result="false"
          >
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Inclusão' || operationType === 'Todas as operações'"
            >
              Incluídos - {{ result.documentosIncluidosFisicos + result.documentosIncluidosDigitais || 0 }}
            </p>
            <p
              style="color: #0399cc;margin-bottom:0"
              v-if="operationType === 'Exclusão' || operationType === 'Todas as operações'"
            >
              Excluídos - {{ result.documentosExcluidosDigitais + result.documentosExcluidosFisicos || 0 }}
            </p>
          </report-result-box>
        </div>
      </v-card>
      <div
        v-if="report === 'Produtividade - Relatório Descritivo'"
        style="display: flex;align-items: center;margin: 20px;"
      >
        <table class="tg">
          <tr>
            <th class="tg-0lax">HORÁRIO</th>
            <th class="tg-0lax">REGISTRO</th>
            <th class="tg-0lax">TÍTULO</th>
            <th class="tg-0lax">TIPO</th>
            <th class="tg-0lax">LOCALIZAÇÃO</th>
            <th class="tg-0lax">OPERAÇÃO</th>
            <th class="tg-0lax">COLABORADOR</th>
          </tr>
          <tr
            v-for="(item, x) in csvData"
            :key="x"
          >
            <td class="tg-0lax">{{item.horario}}</td>
            <td class="tg-0lax">{{item.registro}}</td>
            <td class="tg-0lax">{{item.titulo}}</td>
            <td class="tg-0lax">{{item.tipo}}</td>
            <td class="tg-0lax">{{item.localizacao}}</td>
            <td class="tg-0lax">{{item.operacao}}</td>
            <td class="tg-0lax">{{item.colaborador}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import dateFormatter from '@/mixins/date-formatter';
import reportHeader from '@/components/report-header.vue';
import reportResultBox from '@/components/report-result-box.vue';
import reportResultQuery from '@/components/report-result-query.vue';
import download from '@/mixins/download';

export default {
  components: {
    reportHeader,
    reportResultBox,
    reportResultQuery,
  },
  mixins: [dateFormatter, download],
  data() {
    return {
      report: '',
      operationType: 'Todas as operações',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
      if (to.query.operationType) {
        vm.operationType = to.query.operationType;
      }
      if (to.query.type === 'simples') {
        vm.report = 'Produtividade - Relatório Simples';
      } else {
        vm.report = 'Produtividade - Relatório Descritivo';
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    if (to.query.operationType) {
      this.operationType = this.query.operationType;
    }
    if (to.query.type === 'simples') {
      this.report = 'Produtividade - Relatório Simples';
    } else {
      this.report = 'Produtividade - Relatório Descritivo';
    }
    next();
  },
  computed: {
    ...mapGetters('views/reports/productivity', [
      'result',
      'csvData',
      'query',
      'loading',
    ]),
  },
  methods: {
    ...mapActions('views/reports/productivity', ['afterRouteUpdate']),
  },
};
</script>
<style scoped>
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.tg td {
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #eceff0;
}
.tg th {
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  color: #1e398d;
  border-color: #eceff0;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.back {
  background-color: #fafafa !important;
}
</style>
